var exports = {
  "ec": "SelectionsTab.module__descriptionSmall___SzZDQ1",
  "Uz": "SelectionsTab.module__gridDouble___SzZDQ1",
  "hK": "SelectionsTab.module__gridSingle___SzZDQ1",
  "Wh": "SelectionsTab.module__contentList___SzZDQ1",
  "Ib": "SelectionsTab.module__sliderRow___SzZDQ1",
  "xJ": "SelectionsTab.module__sliderContainer___SzZDQ1",
  "rv": "SelectionsTab.module__sliderValue___SzZDQ1",
  "RE": "SelectionsTab.module__sliderValueDisabled___SzZDQ1",
};

module.exports = exports;
